import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getApiBaseUrl() {
  const currentOrigin = window.location.origin;
  return currentOrigin;
}
